import { UI } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import React from 'react';

export interface CardTitleProps {
  title: string;
}

export const CardTitle: React.FC<CardTitleProps> = ({ title }) => {
  return (
    <UI.Text
      variant="semibold"
      color="neutral.black"
      fontSize={Typography['fontsize.lg']}
      textTransform="uppercase">
      {title}
    </UI.Text>
  );
};
